import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { 
	MainPage, 
	LoginPage, 
	NoticePage,

	CompanyInfoPage,
	CompanyManagePage,

	CenterManagePage,
	UserManagePage,
	JobManagePage,

	GoodsManagePage,
	GoodsJobManagePage,
	GoodsGroupManagePage,

	OrderPage,
	TransPage, 
	TransHistoryPage,
	SettleManagePage,
	
	OrderReturnPage,
	StatsPage,

	NotAuthPage,
	NotFoundPage 
} from 'pages';

@inject("commonStore")
@observer
class App extends Component {
	
	UNSAFE_componentWillMount() {
    this.props.commonStore.onSessionCheck();
	}
	
	render() {
		const { sessionLoginInfo } = this.props.commonStore;
		return (
			<Fragment>
				{sessionLoginInfo === null && <Redirect to={`/login`} />}
				<Switch>
					<Route exact path="/" component={ MainPage } />
					<Route path="/login" component={ LoginPage } />

					{/* 공지사항 */}
					<Route path="/notice" component={ NoticePage } />
          
					{/* YUJIN S&A */}
					<Route path="/companyInfo" component={ CompanyInfoPage } />
					
					{/* 유니폼주문 */}
					<Route path="/orderManage" component={ OrderPage } />


					{/* 주문관리 */}
					<Route path="/transManage" component={ TransPage } />

					{/* 구매이력 */}
					<Route path="/transHistory" component={ TransHistoryPage } />

					{/* 정산관리 */}
					<Route path="/settleManage"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_BRANCH
								|| sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								|| sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER
								|| (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								&& sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG))) ? SettleManagePage : NotAuthPage
						}
					/>
					
					{/* 센터관리 */}
					<Route path="/centerManage"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_BRANCH
								|| sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								|| (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER
                  && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG) 
				  || (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER 
					 && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG )  )) ? CenterManagePage : NotAuthPage
						}
					/>

					{/* 사원관리 */}
					<Route path="/userManage"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_BRANCH
								|| sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								|| (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER
                  && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG))) ? UserManagePage : NotAuthPage
						}
					/>
					
					{/* 직무관리 */}
					<Route path="/jobManage"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								|| (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER
                  && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG))) ? JobManagePage : NotAuthPage
						}
					/>

					{/* 상품이용정보관리 */}
					<Route path="/goodsJobManage"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								|| (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER
                  && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG))) ? GoodsJobManagePage : NotAuthPage
						}
					/>

          {/* 상품관리 */}
					<Route path="/goodsManage"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								|| sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER)) ? GoodsManagePage : NotAuthPage
								}
					/>

					{/* 반품관리 */}
					<Route path="/orderReturn"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN )) ? OrderReturnPage : NotAuthPage
						}
					/>

					{/* 상품군관리 */}
					<Route path="/goodsGroupManage"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
							|| (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
								&& sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG))) ? GoodsGroupManagePage : NotAuthPage
						}
					/>

					{/* 유진정보관리 */}
					<Route path="/companyManage" 
						component={(sessionLoginInfo !== null 
								&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
								&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN)) ? CompanyManagePage : NotAuthPage
						} 
					/>

					{/* 통계 */}
					<Route path="/stats"
						component={(sessionLoginInfo !== null 
							&& sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
							&& (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN 
                || (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER
                  && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG))) ? StatsPage : NotAuthPage
						}
					/>
					<Route component = {NotFoundPage}/>
				</Switch> 
			</Fragment>
		);
	}
};

export default App;